import { LOGGER, updateBotLanguage, updateBotLanguageToLS } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { getBotConfig, getGenericStrings } from '../../index';
import { localeConfig, setter } from './locale.model';
import { LocaleDropdownTemplate } from './localeDropdown.template';

export class LocaleDropdown {
	constructor(props) {
		setter(props);
		this.init();
		this.html = LocaleDropdownTemplate(localeConfig);
		this.initEventHandlers();
	}

	initEventHandlers() {
		ENGT_CHAT.set('onChangeLanguage', this.onChangeLanguage);
		ENGT_CHAT.set('showdropDown', () => {
			const langDropdown = document.querySelector('.engt-lang-dropdown');
			if (langDropdown.style.display === 'none' || langDropdown.style.display === '') {
				langDropdown.style.display = 'flex';
			} else {
				langDropdown.style.display = 'none';
				document.removeEventListener('click', this.hideLangDropdown);
			}

			if (langDropdown.style.display === 'flex') {
				document.addEventListener('click', this.hideLangDropdown);
			}
		});
	}

	async onChangeLanguage(lang = 'en') {
		ENGT_CHAT.set('localeForBotIsChanged', true);
		const language = lang?.id || lang;
		ENGT_CHAT.get('showdropDown')();
		updateBotLanguage(language);

		ENGT_CHAT.get('sendMessage')('locale_update', {
			message: {
				type: 'attribute',
				text: '',
			},
			attributes: [{ name: 'user.language', value: language }],
			skipAppendToDom: true,
		});

		try {
			updateBotLanguageToLS(language);
			await ENGT_CHAT.set('config.botLanguage', language);
			await getBotConfig().then(async () => await getGenericStrings(language));
		} catch (error) {
			LOGGER('Bot Config api failed', error);
		}
	}

	hideLangDropdown(e) {
		if (
			e &&
			document.querySelector('.engt-lang-dropdown')?.style.display === 'flex' &&
			!document.querySelector('.engt-lang-dropdown')?.contains(e.target) &&
			!document.querySelector('#languageDropdown')?.contains(e.target)
		) {
			ENGT_CHAT.get('showdropDown')();
		}
	}

	init() {
		setter({
			enabledLanguages: ENGT_CHAT.get('config.enabledLanguages'),
		});
	}

	render() {
		return this.html;
	}
}
